import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export default function ReusableDatePicker({ label, value, onChange }) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                label={label || 'Select Date'}
                value={value}
                onChange={onChange}
                slotProps={{
                    textField: {
                        size: 'small',      // 👈 ye MUI TextField ka size set karega
                        fullWidth: true,
                    },
                }} />
        </LocalizationProvider>
    );
}
